module.exports = __webpack_public_path__ + "assets/annexum-involved.64a9ba6a.svg";